import React from "react";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { DropdownField } from "forms/fields";
import PropTypes from "prop-types";

import { Translate } from "utils";
import { isRequired } from "utils/validation";

const { t } = new Translate("DealForm");

const Portfolio = ({ portfolios }) => (
  <FormContainer title={t("portfolio.title")}>
    <FormRow columns={1}>
      <Field
        component={DropdownField}
        name="portfolio"
        placeholder={t("placeholders.portfolios")}
        validate={isRequired}
        valueExtractor={(p) => p.name}
        values={portfolios}
      />
    </FormRow>
  </FormContainer>
);

Portfolio.propTypes = {
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default Portfolio;
